import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';

export const DEFAULT_SHIFTS = {
  AM: { label: 'Matin', start_time: '08:30', end_time: '17:30' },
  PM: { label: 'Après-midi / Soir', start_time: '13:00', end_time: '22:00' }
};

export const useShiftSettings = (revision = 0) => {
  const [settings, setSettings] = useState(DEFAULT_SHIFTS);
  useEffect(() => {
    let active = true;
    axios.get(`${API}/internal-staff/shift-settings`, { withCredentials: true })
      .then(r => { if (active) setSettings(r.data); })
      .catch(() => {});
    return () => { active = false; };
  }, [revision]);
  return settings;
};

export const shiftSummary = settings => ['AM', 'PM'].map(code => `${code} ${settings[code].start_time} – ${settings[code].end_time}`).join(' · ');
